module.exports = __webpack_public_path__ + "static/media/CHECKIN_active.fabd4aa5.svg";